import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Typography,
  Box,
  Divider,
  Modal,
  IconButton,
  Tooltip,
  TextField,
  Dialog,
  Tabs,
  Tab,
} from "@mui/material";
import { CloseIcon, ExpandMoreIcon } from "../../icons";
import { useEffect, useRef, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  continueTrainInfoState,
  openHistogramPopState,
  myAIModuleState,
  trainingStateAtom,
  trainUuidState,
  validListStateAtom,
} from "../../recoil/upgrade";
import { clearImgData, removeAIModules, updateAIModules, getMyModuleServer } from "common-lib";
import { fetchProjectInspModels, invalidateInspModels } from "../../services/inspModelCache";
import { useNavigate, useParams } from "react-router-dom";
import { overkillCountState, projectInfoState, thresholdCustomState } from "../../recoil";
import { t } from "i18next";
import { toast } from "react-toastify";
import TrainHistogram from "../train/TrainHistogram";
import TrainSnapshot from "../train/TrainSnapshot";
import { CircleQuestionMarkIcon, Crosshair, GitBranch, List, Maximize2, Minimize2, Server, ZoomIn } from "lucide-react";
import BinImageModal from "./BinImageModal";
import { ImageOutlined } from "@mui/icons-material";
import { Rnd } from "react-rnd";
import { calculateByThreshold, centeredRect } from "../../utils/utils";
import InspRuleOption from "./InspRuleOption";
import SelectionInspModel from "./SelectionInspModel";
import { useEpochList } from "../../hooks/useEpochList";
import { useHistoryMap } from "../../hooks/useHistoryMap";
import { useParsedModels } from "../../hooks/useParsedModels";
import { InspModelItem } from "@types";
import { macBtn } from "../config/DevModeModal";
import TreeModel from "./TreeModel";
import ImageFilter from "../project/ImageFilter";
import DockedFilterSection from "../project/DockedFilterSection";
import { filterDisplayState, filterSettingState } from "../../recoil/filterAtoms";
import ModelCompareModal from "../inspModel/ModelCompareModal";
import { getAISettingInitial } from "common-lib";
import AIOptionRender from "./AIOptionRender";

const MAC_FONT =
  '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Apple SD Gothic Neo", "Helvetica Neue", sans-serif';

interface AIOptionPartProps {
  trainUuid: string;
  isOpenOption: boolean;
  handleSaveModel?: (modelInfo: { name: string; desc: string }) => void;
  setIsOpenServerModal: (open: boolean) => void;
}

export default function AIOptionPart({
  trainUuid,
  isOpenOption,
  handleSaveModel,
  setIsOpenServerModal,
}: AIOptionPartProps) {
  const { id } = useParams();
  const projectData = useRecoilValue(projectInfoState);
  const [filterDisplay, setFilterDisplay] = useRecoilState(filterDisplayState);
  const [filterSetting, setFilterSetting] = useRecoilState(filterSettingState);
  const [open, setOpen] = useState(false);
  const [openOverkillPop, setOpenOverkillPop] = useRecoilState(openHistogramPopState); // EpochCard 스냅샷 모달과 상호 배타
  const [modalTab, setModalTab] = useState(0);
  const [maximized, setMaximized] = useState(false); // 히스토그램 모달 전체화면
  const continueTrainInfo = useRecoilValue(continueTrainInfoState);
  const [isOpenSaveModel, setIsOpenSaveModel] = useState(false);

  const [trainedImageCount, setTrainedImageCount] = useState(0);
  const [changeModuleData, setChangeModuleData] = useState<any>(null);
  const [validList, setValidList] = useRecoilState(validListStateAtom);
  const [isThresholdUpdate, setIsThresholdUpdate] = useState(false);

  const [openImage, setOpenImage] = useState(false);
  const [selectedScore, setSelectedScore] = useState(0);
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [okImgPathInGraph, setOkImgPathInGraph] = useState<string[]>([]);
  const [ngImgPathInGraph, setNgImgPathInGraph] = useState<string[]>([]);

  //변경한 값 저장 안하고 해당 페이지(프로젝트 메인) 벗어날 시 저장 안할건지 물어보기
  const [isModuleChangeSave, setIsModuleChangeSave] = useState(false);
  const myAIModule = useRecoilValue(myAIModuleState);
  const [aiSettingInit, setAISettingInit] = useState<any>(null);
  const rootRef = useRef<HTMLDivElement>(null);

  const [overkillCount, setOverkillCount] = useRecoilState(overkillCountState);
  const [thresholdCustom, setThresholdCustom] = useRecoilState(thresholdCustomState);
  const [thresholdAlert, setThresholdAlert] = useState<{
    overkillCount: number;
  } | null>(null);
  // 검증 결과는 프로젝트 id 키로 저장된다(SelectionInspModel). trainUuid가 "12_web" 꼴이면 Number()가 NaN이라 비어 보인다
  const validDataset = validList[Number(trainUuid)] ?? validList[Number(id)] ?? [];

  const [inspModelList, setInspModelList] = useState<InspModelItem[]>([]);
  const parsedModels = useParsedModels(inspModelList);
  const historyMap = useHistoryMap(parsedModels);
  const epochList = useEpochList(parsedModels);

  const [openTree, setOpenTree] = useState(false);
  const [openCompare, setOpenCompare] = useState(false);

  const [siteOption, setSiteOption] = useState(null);
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((config) => setSiteOption(config.SITE_OPTION));
  }, []);

  const fetchAISetting = async () => {
    if (myAIModule && myAIModule.serverAddress) {
      const initAIOption = await getAISettingInitial(myAIModule.serverAddress);

      console.log("initialOption", initAIOption);
      setAISettingInit(initAIOption);
      // const labelscoreData = myAIModule.options.labelscore.para.threshold_list
      // setThresholdCustom(labelscoreData?.[0] ?? 0);
      console.log(myAIModule);
    }
  };

  const fetchInspModel = async () => {
    try {
      setInspModelList(await fetchProjectInspModels(Number(id)));
    } catch (error: any) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!validList || !validList[Number(id)]) return;
    const list = validList[Number(id)];

    const count = list.filter((item) => item.label === "OK" && item.AILabel === "NG").length;
    setOverkillCount(count);
    // TODO: setThreshold 값
  }, [id]);

  // 학습이 끝나면 백엔드가 과검률 최저 모델을 검사모델로 자동 저장한다 → 끝난 시점에 목록을 다시 불러와 바로 선택 가능하게
  const isTraining = useRecoilValue(trainingStateAtom)[Number(id)];

  useEffect(() => {
    fetchAISetting();
    fetchInspModel();
  }, [isTraining]);

  const handleDataClick = (score: number, data: any) => {
    const OKList: string[] = [];
    const NGList: string[] = [];
    setSelectedScore(score);

    data.forEach((item: any) => {
      if (item.label === "OK") {
        OKList.push(item.path);
      } else if (item.label === "NG") {
        NGList.push(item.path);
      }
    });
    setOkImgPathInGraph(OKList);
    setNgImgPathInGraph(NGList);
    setOpenImage(true);
    // setImageSrc()
  };

  const handleApplyThreshold = async () => {
    if (!validList) return;

    const index = Number(id);
    const currentList = validList[index];

    if (!currentList || currentList.length === 0) return;

    try {
      const data = {
        train_id: trainUuid,
        site: siteOption,
        options: changeModuleData,
        type: "preview",
        total: projectData?.counts.total_count,
        trained_count: trainedImageCount,
        is_complete: true,
      };

      const response = await updateAIModules(myAIModule!.serverAddress, data, myAIModule);

      if (response.length === 0) {
        toast.success(t("ModuleUpdateSuccessMsg"));
      }

      const { updatedList, overkillCount } = calculateByThreshold(currentList, thresholdCustom);

      setValidList((prev) => ({
        ...prev,
        [index]: updatedList,
      }));

      setOverkillCount(overkillCount);
      setThresholdAlert({ overkillCount });
      setTimeout(() => setThresholdAlert(null), 3000);
    } catch (error) {
      console.error("모듈 업데이트 오류:", error);
      toast.error(t("ModuleUpdateErrorMsg"));
    }
  };
  return (
    <>
      <div className="flex flex-col h-full w-full border-r">
        <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
          {/* 검사 결과 */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflowY: "auto",
              backgroundColor: "var(--dk-surface, #fff)",
            }}
          >
            {
              projectData?.step === "검사" && (
                //  (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "4%",
                      px: 1.5,
                      py: 1,
                      flexDirection: "column",
                    }}
                  >
                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography component="span" fontWeight={700}>
                        {t("Model")}
                      </Typography>
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <IconButton
                          id="open-model-compare"
                          onClick={() => setOpenCompare(true)}
                          sx={{
                            p: 0.6,
                            borderRadius: "8px",
                            border: "0.5px solid var(--dk-border, rgba(0,0,0,0.15))",
                            color: "var(--dk-text-2, #6b7280)",
                            "&:hover": {
                              backgroundColor: "rgba(0,0,0,0.04)",
                              borderColor: "var(--dk-border, rgba(0,0,0,0.25))",
                            },
                          }}
                        >
                          <List size={16} />
                        </IconButton>
                        <IconButton
                          onClick={() => setOpenTree(true)}
                          sx={{
                            p: 0.6,
                            borderRadius: "8px",
                            border: "0.5px solid var(--dk-border, rgba(0,0,0,0.15))",
                            color: "var(--dk-text-2, #6b7280)",
                            "&:hover": {
                              backgroundColor: "rgba(0,0,0,0.04)",
                              borderColor: "var(--dk-border, rgba(0,0,0,0.25))",
                            },
                          }}
                        >
                          <GitBranch size={16} />
                        </IconButton>
                      </Box>
                    </Box>
                    <SelectionInspModel
                      historyMap={historyMap}
                      epochList={epochList}
                      inspModelList={inspModelList}
                      thresholdCustom={thresholdCustom}
                      setThresholdCustom={setThresholdCustom}
                    />
                  </Box>
                  <Divider />
                  <div
                    id="insp-histogram"
                    style={{
                      borderTop: "1px solid var(--stroke)",
                      backgroundColor: "var(--dk-surface, #fff)",
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        height: "40px !important",
                        justifyContent: "space-between",
                        alignItems: "center",
                        p: 1,
                      }}
                    >
                      <Typography component="span" fontWeight={700}>
                        {t("Histogram")}
                      </Typography>
                      <IconButton id="histogram-zoom-btn" onClick={() => setOpenOverkillPop(true)}>
                        <ZoomIn style={{ fontSize: "12px" }} />
                      </IconButton>
                    </Box>
                    <Box sx={{ p: 1 }}>
                      <TrainHistogram
                        totalCount={projectData?.counts.total_count}
                        validDataset={validDataset}
                        myAIModule={myAIModule}
                        thresholdCustom={thresholdCustom}
                        setThresholdCustom={setThresholdCustom}
                        setIsThresholdUpdate={setIsThresholdUpdate}
                        changeData={setChangeModuleData}
                        handleDataClick={handleDataClick}
                        handleApplyThreshold={handleApplyThreshold}
                      />
                    </Box>
                  </div>
                  <div style={{ borderTop: "1px solid var(--stroke)" }}>
                    <InspRuleOption
                      thresholdCustom={thresholdCustom}
                      setThresholdCustom={setThresholdCustom}
                      inspModelList={inspModelList}
                    />
                  </div>
                </>
              )
              // )
              //  : (
              //   <Box sx={{ p: 2, color: "text.secondary", fontSize: 13 }}>검사 단계에서 확인할 수 있습니다.</Box>
              // )
            }
          </Box>
        </Box>

        {/* 고정 푸터 */}
        <div style={{ borderTop: "1px solid var(--stroke)" }}>
          <ETCOption setIsOpenSaveModel={setIsOpenSaveModel} setIsOpenServerModal={setIsOpenServerModal} />
        </div>
      </div>

      {filterDisplay === "docked" && (
        <DockedFilterSection>
          <ImageFilter />
        </DockedFilterSection>
      )}
      <Modal
        id="histogram-modal"
        open={openOverkillPop}
        sx={{
          pointerEvents: "none", // ⭐ 핵심
        }}
        onClose={() => setOpenOverkillPop(false)}
        disableEnforceFocus
        disableAutoFocus
        hideBackdrop
        disableRestoreFocus
      >
        <div>
          <Rnd
            default={centeredRect(900, 600)}
            size={maximized ? { width: "100vw", height: "100vh" } : undefined}
            position={maximized ? { x: 0, y: 0 } : undefined}
            disableDragging={maximized}
            enableResizing={!maximized}
            minWidth={600}
            minHeight={400}
            bounds="window"
            dragHandleClassName="drag-handle"
            style={{
              pointerEvents: "auto", // ⭐ 실제 창만 클릭 가능
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
                bgcolor: "background.paper",
                boxShadow: 24,
                borderRadius: 2,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              <Box
                className="drag-handle"
                sx={{
                  p: 2,
                  cursor: "move",
                  borderBottom: "1px solid var(--dk-border, #ddd)",
                  fontWeight: 600,
                }}
              >
                <Typography variant="h5" fontWeight={700} sx={{ display: "flex", alignItems: "center" }}>
                  {t("InspectionResult")}
                  <Tooltip title={t("HistogramTooltipMsg")}>
                    <CircleQuestionMarkIcon style={{ marginLeft: 2 }} />
                  </Tooltip>
                </Typography>

                <IconButton onClick={() => setMaximized((v) => !v)} sx={{ position: "absolute", right: 48, top: 8 }}>
                  {maximized ? <Minimize2 size={18} /> : <Maximize2 size={18} />}
                </IconButton>
                <IconButton
                  id="close-histogram-modal"
                  onClick={() => {
                    setOpenOverkillPop(false);
                    setOpenImage(false);
                    setImageSrc(null);
                  }}
                  sx={{ position: "absolute", right: 8, top: 8 }}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
              <Tabs
                value={modalTab}
                onChange={(_, v) => setModalTab(v)}
                sx={{ minHeight: 36, borderBottom: "1px solid var(--dk-border, #ddd)" }}
              >
                <Tab label={t("Histogram")} sx={{ minHeight: 36, fontSize: 13 }} />
                <Tab label={t("Snapshot")} title={t("SnapshotTooltipMsg")} sx={{ minHeight: 36, fontSize: 13 }} />
              </Tabs>
              <Box sx={{ px: 2, py: 1.5, borderBottom: "1px solid var(--dk-border, #ddd)" }}>
                <SelectionInspModel
                  historyMap={historyMap}
                  epochList={epochList}
                  inspModelList={inspModelList}
                  thresholdCustom={thresholdCustom}
                  setThresholdCustom={setThresholdCustom}
                  hideActions
                />
              </Box>
              {modalTab === 1 && (
                <Box sx={{ flex: 1, minHeight: 0, p: 2, overflowY: "auto" }}>
                  <TrainSnapshot projectId={Number(id)} serverAddress={myAIModule?.serverAddress} />
                </Box>
              )}
              <Box
                sx={{
                  display: modalTab === 0 ? "flex" : "none",
                  justifyContent: "center",
                  flex: 1,
                  minHeight: 0,
                  p: 2,
                  // 그래프 아래 OK/NG 목록까지 내려볼 수 있어야 한다 (hidden이면 잘려서 안 보임)
                  overflow: "auto",
                }}
              >
                <div
                  style={{
                    width: openImage ? "50%" : "100%",
                    minHeight: "100%",
                    display: "flex",
                    flexDirection: "column",
                    transition: "width 0.5s ease",
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{ display: "flex", alignItems: "center", gap: 0.5, color: "text.secondary", mb: 0.5 }}
                  >
                    <Crosshair size={13} />
                    {t("HistogramClickHintMsg")}
                  </Typography>
                  <div style={{ flex: "1 1 320px", minHeight: 300 }}>
                    <TrainHistogram
                      totalCount={projectData?.counts.total_count}
                      validDataset={validDataset}
                      myAIModule={myAIModule}
                      thresholdCustom={thresholdCustom}
                      setThresholdCustom={setThresholdCustom}
                      setIsThresholdUpdate={setIsThresholdUpdate}
                      changeData={setChangeModuleData}
                      handleDataClick={handleDataClick}
                      handleApplyThreshold={handleApplyThreshold}
                      fitHeight
                    />
                  </div>
                  {openImage && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%",
                        gap: 2,
                      }}
                    >
                      <Button variant="outlined" size="small" onClick={() => setOpenImage(false)}>
                        <ZoomIn /> {t("EnlargeView")}
                      </Button>
                    </div>
                  )}
                  {openImage && (
                    <Box sx={{ height: "300px", mt: 2 }}>
                      <Box
                        id="score-img-list"
                        sx={{
                          display: "flex",
                          gap: 4,
                          mt: 2,
                          justifyContent: "space-between",
                        }}
                      >
                        <BinImageModal
                          okPaths={okImgPathInGraph}
                          ngPaths={ngImgPathInGraph}
                          score={selectedScore}
                          setImageSrc={setImageSrc}
                        />
                      </Box>
                    </Box>
                  )}
                </div>
                {openImage && (
                  <div style={{ width: "50%" }}>
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        p: 2,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "hidden",
                        ml: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: "100%",
                          height: "100%",
                          position: "relative",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          color: "text.secondary",
                          border: "2px dashed var(--dk-border, #ddd)",
                          borderRadius: 2,
                          backgroundColor: "var(--dk-surface-2, #fafafa)",
                          overflow: "hidden",
                        }}
                      >
                        {imageSrc ? (
                          <Box
                            component="img"
                            src={imageSrc}
                            sx={{
                              maxWidth: "80%",
                              maxHeight: "80%",
                              objectFit: "contain",
                            }}
                          />
                        ) : (
                          <Box
                            sx={{
                              textAlign: "center",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                            }}
                          >
                            <Box
                              sx={{
                                height: 100,
                                display: "flex",
                                alignItems: "flex-end",
                                justifyContent: "center",
                              }}
                            >
                              <ImageOutlined sx={{ fontSize: 60, opacity: 0.5 }} />
                              <Typography variant="subtitle1" fontWeight={500}>
                                {t("SelectImageMsg")}
                              </Typography>
                            </Box>
                            <Typography variant="body2" sx={{ opacity: 0.7 }}>
                              {t("ScoreRangeImageMsg")}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </div>
                )}
              </Box>
            </Box>
          </Rnd>
        </div>
      </Modal>
      {openTree && (
        <Modal
          open={openTree}
          sx={{ pointerEvents: "none" }}
          onClose={() => setOpenTree(false)}
          disableEnforceFocus
          disableAutoFocus
          hideBackdrop
          disableRestoreFocus
        >
          <div>
            <Rnd
              default={{ x: 200, y: 100, width: 900, height: 600 }}
              minWidth={600}
              minHeight={400}
              bounds="window"
              dragHandleClassName="drag-handle"
              style={{
                pointerEvents: "auto",
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  bgcolor: "background.paper",
                  boxShadow: 24,
                  borderRadius: 2,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <Box
                  className="drag-handle"
                  sx={{
                    p: 2,
                    cursor: "move",
                    borderBottom: "1px solid var(--dk-border, #ddd)",
                    padding: "8px 16px",
                    fontWeight: 600,
                  }}
                >
                  <Typography variant="h5" fontWeight={700} sx={{ display: "flex", alignItems: "center" }}>
                    {t("ModelList")}
                  </Typography>

                  <IconButton
                    onClick={() => {
                      setOpenTree(false);
                    }}
                    sx={{ position: "absolute", right: 8, top: 8 }}
                  >
                    <CloseIcon />
                  </IconButton>
                </Box>

                <Box sx={{ display: "flex", flex: 1, minHeight: 0, overflow: "hidden" }}>
                  <TreeModel />
                </Box>
              </Box>
            </Rnd>
          </div>
        </Modal>
      )}
      {openCompare && (
        <ModelCompareModal
          openCompare={openCompare}
          setOpenCompare={setOpenCompare}
          epochList={epochList}
          inspModelList={inspModelList}
          onSaved={() => {
            invalidateInspModels();
            fetchInspModel();
          }}
        />
      )}
      {isOpenSaveModel && (
        <SaveModelModal
          isOpenSaveModel={isOpenSaveModel}
          setIsOpenSaveModel={setIsOpenSaveModel}
          handleSaveModel={handleSaveModel!!}
        />
      )}
      {thresholdAlert && (
        <Box
          sx={{
            position: "fixed",
            bottom: 24,
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#1e1e2e",
            color: "#fff",
            px: 2.5,
            py: 1.5,
            borderRadius: 2,
            fontSize: "13px",
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
            boxShadow: 4,
            zIndex: 9999,
          }}
        >
          <Typography sx={{ fontSize: "13px", color: "#fff", fontWeight: 600 }}>
            ✅ {t("ThresholdAppliedMsg")}
          </Typography>
          <Typography sx={{ fontSize: "12px", color: "#ccc" }}>
            {t("OverkillImageTotalMsg")} <strong style={{ color: "#fff" }}>{thresholdAlert.overkillCount}</strong>
            {t("CountUnit")}
          </Typography>
        </Box>
      )}
    </>
  );
}

interface ETCOptionProps {
  setIsOpenSaveModel: (open: boolean) => void;
  setIsOpenServerModal: (open: boolean) => void;
}

const ETCOption = ({ setIsOpenSaveModel, setIsOpenServerModal }: ETCOptionProps) => {
  const [myAIModule, setMyAIModule] = useRecoilState(myAIModuleState);
  const navigate = useNavigate();
  const trainUuid = useRecoilValue(trainUuidState);

  const handleRemove = async () => {
    try {
      await clearImgData(myAIModule!.serverAddress, trainUuid);
      await removeAIModules(myAIModule!.serverAddress, trainUuid);
      setMyAIModule(null);
      navigate("/main/projects");
    } catch (error: any) {
      console.error(error);
    }
  };

  const handleGetInfoModule = async () => {
    const myAIModule = await getMyModuleServer(trainUuid, null);
    console.log("myAIModule", myAIModule);
  };

  const handleImportServer = () => {
    setIsOpenServerModal(true);
  };

  return (
    <Accordion
      elevation={0}
      sx={{
        boxShadow: "none",
        borderRadius: 0,
        "&.Mui-expanded": {
          margin: 0,
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          minHeight: 40,
          "&.Mui-expanded": {
            minHeight: 40,
          },
          "& .MuiAccordionSummary-content": {
            margin: 0,
            "&.Mui-expanded": {
              margin: 0,
            },
          },
        }}
      >
        <Typography component="span" fontWeight={700}>
          {t("ServerSetting")}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0, margin: 0 }}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "8px 16px",
            gap: "10px",
          }}
        >
          <Button
            sx={{
              border: "1px solid var(--stroke)",
              height: "34px",
              borderRadius: "4px",
              color: "var(--dash-btn-border)",
              "&:hover": {
                border: "1px solid var(--dash-btn-border)",
              },
            }}
            onClick={() => setIsOpenSaveModel(true)}
          >
            {t("SaveAIOption")}
          </Button>
          <Button
            sx={{
              border: "1px solid var(--stroke)",
              height: "34px",
              borderRadius: "4px",
              color: "var(--dash-btn-border)",
              "&:hover": {
                border: "1px solid var(--dash-btn-border)",
              },
            }}
            onClick={handleImportServer}
          >
            {t("ImportAIServer")}
          </Button>
          <Button
            sx={{
              border: "1px solid var(--stroke)",
              height: "34px",
              borderRadius: "4px",
              color: "var(--dash-btn-border)",
              "&:hover": {
                border: "1px solid var(--dash-btn-border)",
              },
            }}
            onClick={handleRemove}
          >
            {t("RemoveAIOption")}
          </Button>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

interface SaveModelModalProps {
  isOpenSaveModel: boolean;
  setIsOpenSaveModel: (open: boolean) => void;
  handleSaveModel: (modelInfo: { name: string; desc: string }) => void;
}

const SaveModelModal = ({ isOpenSaveModel, setIsOpenSaveModel, handleSaveModel }: SaveModelModalProps) => {
  const trainUuid = useRecoilValue(trainUuidState);
  const myAIModule = useRecoilValue(myAIModuleState);
  const [modelInfo, setModelInfo] = useState<{
    name: string;
    desc: string;
  }>({
    name: "",
    desc: "",
  });

  const handleChangeModelInfo = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setModelInfo((prev) => ({ ...prev, [name]: value }));
  };

  // 열 때마다 입력값 초기화
  useEffect(() => {
    if (isOpenSaveModel) setModelInfo({ name: "", desc: "" });
  }, [isOpenSaveModel]);

  const handleClose = () => setIsOpenSaveModel(false);

  const handleSubmit = () => {
    if (!modelInfo.name.trim()) {
      toast.warn("모델 이름을 입력해주세요.");
      return;
    }
    handleSaveModel({ ...modelInfo, name: modelInfo.name.trim() });
    handleClose();
  };

  const inputSx = {
    "& .MuiOutlinedInput-root": {
      fontSize: 13,
      borderRadius: "8px",
      backgroundColor: "var(--dk-surface, #fff)",
      "& fieldset": { borderColor: "var(--dk-border, rgba(0,0,0,0.12))" },
    },
  };

  return (
    <Dialog
      open={isOpenSaveModel}
      onClose={handleClose}
      slotProps={{ backdrop: { sx: { backgroundColor: "rgba(0,0,0,0.25)", backdropFilter: "blur(4px)" } } }}
      PaperProps={{
        sx: {
          width: 420,
          maxWidth: "calc(100vw - 32px)",
          borderRadius: "14px",
          overflow: "hidden",
          backgroundColor: "rgba(246,246,248,0.96)",
          backdropFilter: "blur(20px)",
          border: "1px solid var(--dk-border, rgba(0,0,0,0.08))",
          boxShadow: "0 20px 60px rgba(0,0,0,0.28)",
          fontFamily: MAC_FONT,
          "& .MuiTypography-root": { fontFamily: MAC_FONT },
        },
      }}
    >
      {/* 신호등 헤더 */}
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          gap: "8px",
          px: 2,
          py: 1.25,
          borderBottom: "1px solid var(--dk-border, rgba(0,0,0,0.06))",
        }}
      >
        {["#ff5f57", "#febc2e", "#28c840"].map((c, i) => (
          <Box
            key={c}
            onClick={i === 0 ? handleClose : undefined}
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: c,
              cursor: i === 0 ? "pointer" : "default",
            }}
          />
        ))}
        <Typography
          sx={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            fontSize: 13,
            fontWeight: 600,
            color: "var(--dk-text, #1d1d1f)",
          }}
        >
          {t("ModelInfoInput")}
        </Typography>
      </Box>

      <Box sx={{ px: 3, pt: 2.5, pb: 2.5 }}>
        <Box
          sx={{
            bgcolor: "var(--dk-surface, #fff)",
            borderRadius: "10px",
            border: "1px solid var(--dk-border, rgba(0,0,0,0.08))",
            px: 2,
            py: 1.5,
          }}
        >
          <Typography sx={{ fontSize: 12, color: "var(--dk-text-2, #86868b)", mb: 0.5 }}>{t("Name")}</Typography>
          <TextField
            name="name"
            fullWidth
            size="small"
            autoFocus
            value={modelInfo.name}
            onChange={handleChangeModelInfo}
            onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
            inputProps={{ maxLength: 200 }}
            sx={{ ...inputSx, mb: 1.5 }}
          />
          <Typography sx={{ fontSize: 12, color: "var(--dk-text-2, #86868b)", mb: 0.5 }}>{t("Description")}</Typography>
          <TextField
            name="desc"
            fullWidth
            multiline
            rows={3}
            value={modelInfo.desc}
            onChange={handleChangeModelInfo}
            inputProps={{ maxLength: 250 }}
            sx={inputSx}
          />
        </Box>

        <Box sx={{ display: "flex", gap: 1.25, mt: 2 }}>
          <Button fullWidth onClick={handleClose} disableElevation sx={macBtn("secondary")}>
            {t("Cancel")}
          </Button>
          <Button fullWidth onClick={handleSubmit} disableElevation sx={macBtn("primary")}>
            {t("Save")}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};
